export default (pValue, decimalMax = 2, decimalMin = 0, defaultReturn = '') => {
  if (pValue && !isNaN(pValue)) {
    const formatter = Intl.NumberFormat('pt-BR', {
      style: 'decimal',
      maximumFractionDigits: decimalMax,
      minimumFractionDigits: decimalMin
    })
    return formatter.format(pValue)
  }

  return defaultReturn
}



// WEBPACK FOOTER //
// ./src/components/primitives/helpers/filters/DecimalNumber.js